// /entradas — Lista real de compras del usuario con QR inline (FASE 2)
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Ticket, Clock, MapPin } from 'lucide-react';
import { COLORS, fmtDayPretty, fmtTime } from './designSystem';
import { BottomNav, PhoneShell } from './components';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TicketsPage() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('upcoming');
  const [tickets, setTickets] = useState(null);
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('user_token');
    if (!token) { setLoggedIn(false); setTickets([]); return; }
    setLoggedIn(true);
    fetch(`${API}/me/tickets`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.ok ? r.json() : [])
      .then((d) => setTickets(Array.isArray(d) ? d : []))
      .catch(() => setTickets([]));
  }, []);

  const now = Date.now();
  const bucket = (t) => {
    const when = t.fecha_inicio ? new Date(t.fecha_inicio).getTime() : (t.created_at ? new Date(t.created_at).getTime() + 86400000 : now + 86400000);
    return when >= now ? 'upcoming' : 'past';
  };
  const visible = (tickets || []).filter((t) => bucket(t) === tab);

  return (
    <PhoneShell>
      <header className="px-5 pt-6 pb-4">
        <h1 className="text-white text-2xl font-extrabold mb-4">Mis entradas</h1>
        <div className="flex gap-2 p-1 rounded-full" style={{ backgroundColor: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
          <button onClick={() => setTab('upcoming')} className="flex-1 py-2 rounded-full text-sm font-semibold" style={{ backgroundColor: tab === 'upcoming' ? COLORS.primary : 'transparent', color: tab === 'upcoming' ? '#fff' : COLORS.textMuted }} data-testid="tickets-tab-upcoming">Próximas</button>
          <button onClick={() => setTab('past')} className="flex-1 py-2 rounded-full text-sm font-semibold" style={{ backgroundColor: tab === 'past' ? COLORS.primary : 'transparent', color: tab === 'past' ? '#fff' : COLORS.textMuted }} data-testid="tickets-tab-past">Pasadas</button>
        </div>
      </header>

      <section className="px-5">
        {tickets === null ? (
          <p className="text-sm" style={{ color: COLORS.textMuted }}>Cargando…</p>
        ) : visible.length === 0 ? (
          <div className="pt-10 text-center">
            <div className="w-20 h-20 mx-auto mb-5 flex items-center justify-center rounded-full" style={{ backgroundColor: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
              <Ticket size={32} color={COLORS.textMuted} />
            </div>
            <h3 className="text-white font-bold text-lg mb-1">Aún no tienes entradas</h3>
            <p className="text-sm mb-6" style={{ color: COLORS.textMuted }}>{loggedIn ? 'Cuando compres una entrada, aparecerá aquí.' : 'Inicia sesión para ver tus entradas.'}</p>
            <button onClick={() => navigate('/eventos')} className="px-6 py-3 rounded-full font-bold text-white" style={{ backgroundColor: COLORS.primary }} data-testid="tickets-explore-btn">Explorar eventos</button>
          </div>
        ) : (
          <div className="space-y-3 pb-6">
            {visible.map((t) => (
              <article key={t.payment_intent_id} className="rounded-[20px] overflow-hidden" style={{ backgroundColor: COLORS.surface, border: `1px solid ${COLORS.border}` }} data-testid={`ticket-${t.payment_intent_id}`}>
                <div className="p-4">
                  <h3 className="text-white font-bold text-base mb-1 line-clamp-2">{t.event_name}</h3>
                  <p className="flex items-center gap-1.5 text-xs mt-1" style={{ color: COLORS.textMuted }}><MapPin size={12} />{t.venue || '—'}</p>
                  <p className="flex items-center gap-1.5 text-xs mt-1" style={{ color: COLORS.textMuted }}><Clock size={12} /><span className="capitalize">{t.fecha_inicio ? `${fmtDayPretty(t.fecha_inicio)} · ${fmtTime(t.fecha_inicio)}` : (t.day || '—')}</span></p>
                  <div className="flex items-center justify-between mt-3 pt-3 border-t" style={{ borderColor: COLORS.border }}>
                    <span className="text-xs" style={{ color: COLORS.textMuted }}>Cantidad</span>
                    <span className="text-white font-bold">x{t.quantity}</span>
                  </div>
                </div>
                {t.qr_png_base64 ? (
                  <div className="bg-white px-4 py-5 text-center">
                    <img src={`data:image/png;base64,${t.qr_png_base64}`} alt="QR" className="w-40 h-40 mx-auto block" data-testid={`ticket-qr-${t.payment_intent_id}`} />
                    <p className="mt-3 text-[11px] font-mono tracking-widest font-bold" style={{ color: '#111' }}>{t.short_code}</p>
                    <p className="mt-1 text-[11px]" style={{ color: '#666' }}>Muestra este QR en la puerta</p>
                  </div>
                ) : (
                  <div className="px-4 pb-4 text-xs" style={{ color: COLORS.textMuted }}>QR no disponible — contacta con nosotros.</div>
                )}
              </article>
            ))}
          </div>
        )}
      </section>
      <BottomNav />
    </PhoneShell>
  );
}
